module.exports = __webpack_public_path__ + "static/capitol-4-6ee67874e316d4972643c1b7a0a04978.jpg";